import { useLocation } from "react-router-dom";

export interface HamburgerMenuConfig {
  showBackButton?: boolean;
  title?: string;
  hideOnRoutes?: string[];
  customClassName?: string;
  hideMenu?: boolean;
  backButtonRoute?: string;
}

const routeConfigs: Record<string, HamburgerMenuConfig> = {
  "/": {
    showBackButton: false,
    title: undefined,
  },

  "/item": {
    hideMenu: true,
  },

  "/menu": {
    hideMenu: true,
  },

  "/info": {
    showBackButton: true,
    title: "Informações",
    backButtonRoute: "/",
  },

  "/cart": {
    showBackButton: true,
    title: "Sacola",
    backButtonRoute: "/",
  },

  "/cart/checkout": {
    hideMenu: true,
  },

  "/cart/order-confirmed": {
    hideMenu: true,
  },

  "/cart/new-address": {
    showBackButton: true,
    title: "Novo Endereço",
    backButtonRoute: "/cart/checkout/service",
  },

  "/cart/profile-data": {
    showBackButton: true,
    title: "Dados do Perfil",
    backButtonRoute: "/cart",
  },

  "/profile": {
    showBackButton: true,
    title: "Meu Perfil",
    backButtonRoute: "/",
  },

  "/profile/addresses": {
    showBackButton: true,
    title: "Meus Endereços",
    backButtonRoute: "/profile",
  },

  "/profile/addresses/new": {
    showBackButton: true,
    title: "Novo Endereço",
    backButtonRoute: "/profile/addresses",
  },

  "/profile/auth": {
    hideMenu: true,
  },

  "/profile/loyalty": {
    showBackButton: true,
    title: "Fidelidade",
    backButtonRoute: "/profile",
  },

  "/profile/orders": {
    showBackButton: true,
    title: "Meus Pedidos",
    backButtonRoute: "/",
  },
};

const orderDetailsConfig: HamburgerMenuConfig = {
  showBackButton: true,
  title: "Detalhes do Pedido",
  backButtonRoute: "/profile/orders",
};

const unknownRouteConfig: HamburgerMenuConfig = {
  showBackButton: true,
  title: undefined,
  backButtonRoute: "/",
};

function resolveConfig(pathname: string): HamburgerMenuConfig {
  const config = routeConfigs[pathname];
  if (config) return config;

  if (pathname.startsWith("/item/")) {
    return routeConfigs["/item"];
  }
  if (pathname.startsWith("/cart/checkout")) {
    return routeConfigs["/cart/checkout"];
  }
  if (pathname.startsWith("/cart/order-confirmed/")) {
    return routeConfigs["/cart/order-confirmed"];
  }
  if (pathname.startsWith("/profile/orders/") && pathname !== "/profile/orders") {
    return orderDetailsConfig;
  }

  return unknownRouteConfig;
}

export function useHamburgerMenuConfig(): HamburgerMenuConfig {
  const location = useLocation();
  return resolveConfig(location.pathname);
}
